let apiBaseUrl = "";
let socketUrl = "";
let cloudFrontUrl = "";

let appStage = process.env.REACT_APP_STAGE;

if (appStage == "dev") {
  apiBaseUrl = "https://irbackend.dreamztesting.com/api/v1/";
  socketUrl = "https://socket.insiderodeo.com:6670/";
  cloudFrontUrl = "https://d22z93bum7xzz9.cloudfront.net/assets/share_image/";
} else if (appStage == "stage") {
  apiBaseUrl = "https://insiderodeo-api.stage.tetonridge.io/api/v1/";
  socketUrl = "https://pfr-socket.stage.tetonridge.io/";
  cloudFrontUrl = "https://stage-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
} else if (appStage == "prod") {
  apiBaseUrl = "https://api.insiderodeo.com/api/v1/";
  socketUrl = "https://ws.insiderodeo.com/";
  cloudFrontUrl = "https://production-insiderodeo-api.s3.amazonaws.com/assets/share_image/";
}

export const API_BASE_URL = apiBaseUrl;
export const SOCKETURL = socketUrl;
export const CLOUDFRONT_URL = cloudFrontUrl;

// Socket.IO transport configuration
// Prioritize WebSocket for mobile optimization (75% iOS users) with polling fallback
// WebSocket-first provides better performance while maintaining compatibility
export const SOCKET_TRANSPORTS = ['websocket', 'polling']; // WebSocket-first, polling fallback
